import { collection, query, where, onSnapshot } from "firebase/firestore";

export const startCollectingTodayTimeRecordsByProjectUseCase = async ({
  firebaseFirestore,
  currentUser,
  projectId,
  setTodayTimeRecordsByProject,
}) => {
  if (!currentUser || !firebaseFirestore) return;

  if (!projectId) {
    console.error("No projectId provided and no active project found.");
    return;
  }

  console.log(
    `Start collecting today's time records for projectId: ${projectId}`
  );

  const timeRecordsRef = collection(
    firebaseFirestore,
    `users/${currentUser.uid}/time_records`
  );

  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);

  const todaysProjectRecordsQuery = query(
    timeRecordsRef,
    where("projectId", "==", String(projectId)),
    where("startedTime", ">=", startOfToday.getTime()),
    where("startedTime", "<=", endOfToday.getTime())
  );

  console.log(`Fetching today's time records for projectId: ${projectId}`);

  const unsubscribe = onSnapshot(todaysProjectRecordsQuery, (snapshot) => {
    const timeRecords = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    console.log(
      `Fetched today's time records for projectId: ${projectId}:`,
      timeRecords
    );
    setTodayTimeRecordsByProject(timeRecords);
  });

  return unsubscribe;
};
